const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export { API };

export const adminToken = () => localStorage.getItem("rom_admin_token") || "";

export async function adminFetch(path, opts = {}) {
  return _fetch("rom_admin_token", path, opts);
}

export const creatorToken = () => localStorage.getItem("rom_creator_token") || "";

export async function creatorFetch(path, opts = {}) {
  return _fetch("rom_creator_token", path, opts);
}

async function _fetch(tokenKey, path, opts = {}) {
  const token = localStorage.getItem(tokenKey) || "";
  const res = await fetch(`${API}${path}`, {
    ...opts,
    headers: {
      ...(opts.body && !(opts.body instanceof FormData) ? { "Content-Type": "application/json" } : {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.detail || "কাজ হয়নি — আবার চেষ্টা করুন");
  return data;
}
